import { render, staticRenderFns } from "./HistoricalDataConservation.vue?vue&type=template&id=5daa3cca&scoped=true"
import script from "./HistoricalDataConservation.vue?vue&type=script&lang=js"
export * from "./HistoricalDataConservation.vue?vue&type=script&lang=js"
import style0 from "./HistoricalDataConservation.vue?vue&type=style&index=0&id=5daa3cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daa3cca",
  null
  
)

export default component.exports